import React from "react";
import Login from "../components/Login";

const LoginPage = () => {
  return (
    <div
      className="w-100 bg-custom-tertiary d-flex justify-content-center align-items-center"
      style={{ minHeight: "100vh" }}
    >
      <Login />
    </div>
  );
};

export default LoginPage;
